import { useCallback } from 'react'
import { Workspace } from 'types/entities'
import { WorkspaceType } from 'lib/generated/api'
import useIsInternalUser from 'hooks/useIsInternalUser'

const useInternalWorkspaces = () => {
  const [isInternalUser] = useIsInternalUser()

  return useCallback(
    (workspace: Workspace[]) => {
      return isInternalUser
        ? workspace
        : workspace.filter(
            ({ type }) =>
              type &&
              [`${WorkspaceType.Building}`, `${WorkspaceType.Office}`].includes(
                type
              )
          )
    },
    [isInternalUser]
  )
}

export default useInternalWorkspaces
